import {days} from '@/constants';
import {militaryTimeToStandard} from '@/utils';

export const dayOfWeekIndexToWord = (dayIndex) => {
  return days[dayIndex];
};
export const formatScheduleTime = (scheduleDatetime) => {
  const time = scheduleDatetime.split('T')[1].split('.')[0];
  const timeString = time.substring(0, time.length - 3);
  return militaryTimeToStandard(timeString);
};

export const decimalToDays = (decimal) => {
  if (!decimal) return 'None';

  const binary = (decimal).toString(2).split('').reverse();
  const availableDays = binary
    .map((day, index) => day === '1' ? days[index] : '')
    .filter(days => !!days.length)

  if (availableDays.length === 1) {
    return `Only on ${availableDays[0]}`;
  } else if (availableDays.length === 2) {
    return `Only on ${availableDays.join(' and ')}`;
  } else {
    const lastDay = availableDays.pop();
    return `${availableDays.join(', ')} and ${lastDay}`;
  }
};
export const clinicTypeAvailabilityText = ({onsite, virtual}) => {
  let text = 'Not available.';

  if (onsite && virtual) {
    text = 'Virtual and On-site consultation.';
  } else if (onsite) {
    text = 'On-site consultation.';
  } else if (virtual) {
    text = 'Virtual consultation.';
  }

  return text;
};
export const doctorNameWithTitle = (doctorName) => {
  return `Dr. ${doctorName}`;
};
export const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);
